// SWIPER
const coSwiper1 = new Swiper('.co-acne-4-tabs-cell-1 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-1 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-1 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-1 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper2 = new Swiper('.co-acne-4-tabs-cell-2 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-2 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-2 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-2 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper3 = new Swiper('.co-acne-4-tabs-cell-3 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-3 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-3 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-3 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper4 = new Swiper('.co-acne-4-tabs-cell-4 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-4 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-4 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-4 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});

// TABS
(function() {
    'use strict';

    // Configuration
    const config = {
        navigationSelector: '.co-acne-tabs-button',
        contentSections: [
            '.co-acne-4-tabs-wrapper',
            '.co-acne-5-tabs-wrapper',
            '.co-acne-6-tabs-wrapper',
            '.co-acne-7-tabs-wrapper'
        ],
        activeClass: 'co-active'
    };

    // Initialize
    function init() {
        const navButtons = document.querySelectorAll(config.navigationSelector);
        
        // Add click listeners to navigation buttons
        navButtons.forEach((button, index) => {
            button.addEventListener('click', function() {
                const tabIndex = parseInt(this.getAttribute('data-tab-index'));
                activateTabCells(tabIndex);
                updateNavigationButtons(this);
            });

            // Keyboard navigation
            button.addEventListener('keydown', function(e) {
                handleKeyboardNavigation(e, index, navButtons);
            });
        });

        // Initialize first tab as active
        activateTabCells(0);
    }

    // Activate tab cells across all sections
    function activateTabCells(tabIndex) {
        config.contentSections.forEach(sectionSelector => {
            const wrapper = document.querySelector(sectionSelector);
            if (!wrapper) return;

            const cells = wrapper.children;
            
            // Remove active class from all cells in this section
            Array.from(cells).forEach(cell => {
                if (cell.classList.contains('section-label')) return; // Skip labels
                cell.classList.remove(config.activeClass);
            });

            // Add active class to the selected cell if it exists
            if (cells[tabIndex]) {
                cells[tabIndex].classList.add(config.activeClass);
            }
        });

        // Announce to screen readers
        announceChange(tabIndex + 1);
    }

    // Update navigation button states
    function updateNavigationButtons(activeButton) {
        const navButtons = document.querySelectorAll(config.navigationSelector);
        
        navButtons.forEach(button => {
            button.classList.remove(config.activeClass);
            button.setAttribute('aria-selected', 'false');
        });

        activeButton.classList.add(config.activeClass);
        activeButton.setAttribute('aria-selected', 'true');
    }

    // Keyboard navigation
    function handleKeyboardNavigation(e, currentIndex, navButtons) {
        let targetIndex = currentIndex;
        
        switch(e.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                targetIndex = currentIndex > 0 ? currentIndex - 1 : navButtons.length - 1;
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                targetIndex = currentIndex < navButtons.length - 1 ? currentIndex + 1 : 0;
                break;
            case 'Home':
                e.preventDefault();
                targetIndex = 0;
                break;
            case 'End':
                e.preventDefault();
                targetIndex = navButtons.length - 1;
                break;
            default:
                return;
        }
        
        navButtons[targetIndex].focus();
        navButtons[targetIndex].click();
    }

    // Screen reader announcement
    function announceChange(tabNumber) {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.setAttribute('aria-atomic', 'true');
        announcement.style.position = 'absolute';
        announcement.style.left = '-10000px';
        announcement.textContent = `Tab ${tabNumber} is now active across all sections`;
        
        document.body.appendChild(announcement);
        setTimeout(() => {
            document.body.removeChild(announcement);
        }, 1000);
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// BEFORE AFTER
class ImageCompare {
            constructor(element) {
                this.element = element;
                this.overlay = element.querySelector('.image-compare-overlay');
                this.slider = element.querySelector('.image-compare-slider');
                this.overlayImage = this.overlay.querySelector('img');
                this.isResizing = false;
                
                this.init();
            }

            init() {
                // Set initial dimensions
                this.updateDimensions();
                
                // Bind events
                this.slider.addEventListener('mousedown', (e) => this.startResize(e));
                this.element.addEventListener('mousedown', (e) => this.startResize(e));
                
                // Touch events
                this.slider.addEventListener('touchstart', (e) => this.startResize(e));
                this.element.addEventListener('touchstart', (e) => this.startResize(e));
                
                // Window resize
                window.addEventListener('resize', () => this.updateDimensions());
            }

            updateDimensions() {
                const width = this.element.offsetWidth;
                this.overlayImage.style.width = width + 'px';
            }

            startResize(e) {
                e.preventDefault();
                this.isResizing = true;
                
                // Get initial position
                const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
                this.updatePosition(x);
                
                // Bind move and end events
                const moveHandler = (e) => this.resize(e);
                const endHandler = () => this.endResize(moveHandler, endHandler);
                
                if (e.type.includes('touch')) {
                    document.addEventListener('touchmove', moveHandler);
                    document.addEventListener('touchend', endHandler);
                } else {
                    document.addEventListener('mousemove', moveHandler);
                    document.addEventListener('mouseup', endHandler);
                }
            }

            resize(e) {
                if (!this.isResizing) return;
                
                const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
                this.updatePosition(x);
            }

            updatePosition(x) {
                const rect = this.element.getBoundingClientRect();
                let position = x - rect.left;
                
                // Constrain to bounds
                position = Math.max(0, Math.min(position, rect.width));
                
                // Calculate percentage
                const percentage = (position / rect.width) * 100;
                
                // Update elements
                this.overlay.style.width = percentage + '%';
                this.slider.style.left = percentage + '%';
            }

            endResize(moveHandler, endHandler) {
                this.isResizing = false;
                
                // Remove event listeners
                document.removeEventListener('mousemove', moveHandler);
                document.removeEventListener('mouseup', endHandler);
                document.removeEventListener('touchmove', moveHandler);
                document.removeEventListener('touchend', endHandler);
            }
        }

        // Initialize all comparison elements
        document.addEventListener('DOMContentLoaded', () => {
            const comparisons = document.querySelectorAll('[data-comparison]');
            comparisons.forEach(element => {
                new ImageCompare(element);
            });
        });